var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Popper, autocompleteClasses, styled } from '@mui/material';
import React from 'react';
import { Autocomplete } from '../Autocomplete';
import { MenuItem } from '../Menu';
import { TextField } from '../TextField';
import { Typography } from '../Typography';
import { VirtualizedList } from '../VirtualizedList';
import { ListRow } from './ListRow';
const StyledPopper = styled(Popper)({
    [`& .${autocompleteClasses.listbox}`]: {
        boxSizing: 'border-box',
        '& ul': {
            padding: 0,
            margin: 0,
        },
    },
});
export const MultipleSelect = (_a) => {
    var { inputLabel } = _a, autocompleteProps = __rest(_a, ["inputLabel"]);
    return (React.createElement(Autocomplete, Object.assign({ disableListWrap: true, PopperComponent: StyledPopper, ListboxComponent: (props) => (React.createElement(VirtualizedList, Object.assign({}, props, { itemSize: 36, RowComponent: ListRow, useOuterContext: true }))), multiple: true, limitTags: 1, getLimitTagsText: (more) => `+${more}`, size: "small", disableCloseOnSelect: true, fullWidth: true, filterSelectedOptions: true, renderInput: (params) => React.createElement(TextField, Object.assign({}, params, { label: inputLabel, size: "small" })), renderOption: (props, option, state) => {
            var _a, _b;
            return (React.createElement(MenuItem, Object.assign({}, props, { selected: state.selected }),
                React.createElement(Typography, { variant: "body2", noWrap: true }, (_b = (_a = autocompleteProps.getOptionLabel) === null || _a === void 0 ? void 0 : _a.call(autocompleteProps, option)) !== null && _b !== void 0 ? _b : '')));
        } }, autocompleteProps)));
};
